export enum BannerType {
  NOT_RELATED = 1,
  LINK = 2,
  CHARITY = 3,
  CAMPAIGN = 4,
  ORPHAN = 5,
}



export const getBannerType = (status: BannerType) => {
  switch (status) {
    case BannerType.NOT_RELATED:
      return "not_related";
    case BannerType.LINK:
      return "link";
    case BannerType.CHARITY:
      return "charity";
    case BannerType.CAMPAIGN:
      return "campaign";
    case BannerType.ORPHAN:
      return "orphan";
    default:
      return "red";
  }
};
// bannerFor.ts
export enum BannerFor {
  CHARITY = 1,
  DONATION = 2,
}

export const getBannerTypeColor = (status: BannerType) => {
  switch (status) {

    case BannerType.LINK:
      return "orange";
    case BannerType.ORPHAN:
      return "green";
    case BannerType.CAMPAIGN:
      return "yellow";
    case BannerType.NOT_RELATED:
      return "#9c27b0";
    default:
      return "red";
  }
};
export const getBannerFor = (type: BannerFor): string => {
  switch (type) {
      case BannerFor.CHARITY:
          return "charity";
      case BannerFor.DONATION:
          return "donation";
      default:
          return "";
  }
};

// bannerStatus.ts
export enum BannerStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}

export const getBannerStatus = (status: BannerStatus): string => {
  switch (status) {
      case BannerStatus.ACTIVE:
          return "active";
      case BannerStatus.INACTIVE:
          return "inactive";
      default:
          return "";
  }
};
